import React from 'react';
import One from '../layouts/one';
import { Animated } from 'react-animated-css';
import { preload } from '../../helpers';
import { Modal, ModalBody } from 'reactstrap';
import _ from 'lodash';

class Gallery extends React.Component {

    state = {}

    componentWillMount() { preload(this.props, true); }

    renderYear = (alumni, index) => {
        let k = ['1011', '1012', '1014', '1013', 1015, 1016]
        if (index % 2) {
            return (
                <Animated animationIn="fadeIn" key={index}>
                    <div className="bg-whiteish" style={{ position: 'relative', overflow: 'hidden' }}>
                        <div className="d-flex flex-column w3-container w3-content pb-8 pt-8" style={{ zIndex: 1, minHeight: 300 }}>
                            <div style={{ height: 300, marginBottom: 5 }} className="d-flex flex-row">
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                            </div>
                            <div style={{ height: 300, marginBottom: 5 }} className="d-flex flex-row">
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                            </div>
                        </div>
                        <div style={{ height: 250 }} />
                        <span className="super-hero-text black anton w-100 text-right block" style={{ maxLines: 1, wordBreak: false, position: 'absolute', bottom: -60, opacity: 0.05, }}>2021</span>
                    </div>
                </Animated>)
        } else {
            return (
                <Animated animationIn="fadeIn" key={index}>
                    <div className="bg-white" style={{ position: 'relative', overflow: 'hidden' }}>
                        <span className="super-hero-text black anton w-100 text-left block" style={{ position: 'absolute', bottom: -60, opacity: 0.05, }}>2020</span>
                        <div className="d-flex flex-column w3-container w3-content pb-8 pt-8" style={{ zIndex: 1, minHeight: 300 }}>
                            <div style={{ height: 300 }} className="d-flex flex-row">
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} onClick={() => this.setState({ selected: `https://picsum.photos/id/${_.sample(k)}/200/300` })} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                                <div style={{ width: 10 }} />
                                <div className=" w-100 cover pointer " style={{ background: `url(${`https://picsum.photos/id/${_.sample(k)}/200/300`}) no-repeat center center black` }} />
                            </div>
                        </div>
                        <div style={{ height: 250 }} />
                    </div>
                </Animated>
            )
        }
    }

    toggle = () => this.setState({ selected: null });

    render() {
        const { selected } = this.state;
        let years = [{}, {}];
        return (
            <One nbs="gallery" bi="gallery.png">
                <section>
                    <div style={{ height: 600, zIndex: 1, }} className="d-flex flex-column justify-content-center">
                        <Animated animationIn="fadeInLeft" className="w-100 align-self-center w3-container w3-content" style={{ zIndex: 1 }}>
                            <h1 className="hero-text anton white text-center">GALLERY</h1>
                        </Animated>
                    </div>
                    {years && years.map((year, index) => this.renderYear(year, index))}

                    <Modal isOpen={selected ? true : false} toggle={this.toggle}>
                        <ModalBody>
                            <img src={selected} alt="" className="w-100" />
                        </ModalBody>
                    </Modal>
                    </section>
            </One>
        );
    }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/index.js